import PwTable from './PwTable';
export default PwTable;
